/*
 * 获取一些公共的数据
 */

import {request} from "./requests";
import {Entity} from "./converter";
import {vue} from "../main";

export async function getSlogans() {
    let slogans = await request({
        url: `/slogans`,
        method: 'get',
        retriable: true
    });
    console.log('get slogans', slogans);
    vue.$store.commit('setSlogans', slogans);
}

/**
 * get all confs
 * @return {Promise<void>}
 */
export async function getConfs() {
    let confs = await request({
        url: `/confs`,
        method: 'get',
        retriable: true
    });
    console.log('get confs', confs);
    vue.$store.commit('setI', confs.i);
    vue.$store.commit('setPid', confs.pId);
    vue.$store.commit('setDisplayCtrl', confs.displayCtrl); // 设置前端敏感元素的展示，对应后台配置的 frontend 属性
    vue.$store.commit('setSlogans', confs.slogans);
    vue.$store.commit('setChannels', confs.channels);
    vue.$store.commit('setNewUserRewardPoints', confs.newUserRewardPoints); // 新用户注册并激活邮箱后可获得的积分
    vue.$store.commit('setTipoffs', confs.tipoffs);
    vue.$store.commit('setLatestVersion', confs.release);
}



// WEBPACK FOOTER //
// ./src/data/commons.js